import { render, staticRenderFns } from "./SignupTokenModal.vue?vue&type=template&id=6db3568e&scoped=true&"
import script from "./SignupTokenModal.vue?vue&type=script&lang=js&"
export * from "./SignupTokenModal.vue?vue&type=script&lang=js&"
import style0 from "./SignupTokenModal.vue?vue&type=style&index=0&id=6db3568e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db3568e",
  null
  
)

export default component.exports